import { Component, OnInit, ViewChild } from '@angular/core';
import { WelcomePage } from "../welcome/welcome";
import { SignupPage } from "../signup/signup";
import { AlertController, LoadingController, NavController } from "ionic-angular";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { ResetpasswordPage } from "../resetpassword/resetpassword";
import { RestaurantslistPage } from "../restaurantslist/restaurantslist";
import { user } from "../../shared/user";
import { AuthProvider } from "../../providers/authservice/auth";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { LoginServiceProvider } from "../../providers/authservice/loginService";
import { AngularFireDatabase } from 'angularfire2/database';
import {SignupSuccessPage} from "../signup-success/signup-success";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit {
  @ViewChild('loginAnimate') logAnimate;

  loginForm: FormGroup;
  email: AbstractControl;
  password: AbstractControl;
  message: string;
  isError: boolean = false;
  user: user;
  isSubmitted: boolean = false;
  local_storage_user: any = [];

  constructor(
    public navCtrl: NavController,
    public animation: SmartanimationProvider,
    public authProvider: AuthProvider,
    public fb: FormBuilder,
    public loadingCtrl: LoadingController,
    public alrtCtrl: AlertController,
    public loginService: LoginServiceProvider,
    private db: AngularFireDatabase
  ) {
    // Constructor Function
  }


  // ngInit
  ngOnInit() {

    // form inint on
    this.loginForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.min(1)])]
    });
    this.email = this.loginForm.controls['email'];
    this.password = this.loginForm.controls['password'];
    // this.local_storage_user = JSON.parse(localStorage.getItem('UserId'));
    // this.email=this.local_storage_user.email;
  }



  login(login_Form: any) {

    if (this.loginForm.valid) {
      let loading = this.loadingCtrl.create({
        content: 'Signing you please wait ',
        dismissOnPageChange: true
      });
      loading.present();
      this.loginService.userLogin(login_Form.email, login_Form.password)
        .then((result) => {
          localStorage.removeItem('chktok');
          let currentUser = this.loginService.getUserId();
      //    console.log(currentUser);
          localStorage.setItem('UserId', JSON.stringify(currentUser));

          if (currentUser.uid === 'undefined') {
            this.alertMessage('Your email not registered ', "please signup or contact our customer care");
          }
          // else if (currentUser.emailVerified === false) {
          //   loading.dismiss().then(() => {
          //     this.alertMessage('Your email not verified', "your email address hasn't been verified yet, we sent a verification link to your email id");
          //     currentUser.sendEmailVerification().then((result) => {
          //       console.log("Email Sent");
          //     });
          //   })
          // } 
          else {
            let path = `users/${currentUser.uid}`;
            this.db.object(path).valueChanges().subscribe(t => {
              localStorage.setItem('UserObj', JSON.stringify(t))
        //      console.log(t);
              loading.dismiss().then(() => {
                window.location.reload();
                //this.navCtrl.setRoot(WelcomePage);
              })
            });
          }
        }).catch((error) => {
          loading.dismiss().then(() => {
            this.alertMessage('Login Error', error.message);
          })
        })
    }


    // this.isSubmitted = false;
    // this.isError = false;
    // let obj = this.authProvider.emailLogin(this.email, this.password);
    // if (obj.uid != undefined) {
    //   this.navCtrl.push(HomePage, obj);

    /*let userref = firebase.database().ref();
     let path = `users/${obj.uid}`;
     userref.child(path).on('value', (snap) => {
     this.isSubmitted = true;
     this.user = snap.val();
     / console.log(snap.val())
     });*/

    // }
    // else if (obj.message != undefined) {
    //   this.isSubmitted = true;
    //   this.isError = true;
    //   this.message = obj.message;
    // }
    // console.log(obj);
  }

  // Login with google
  signInWithGoogle() {
    this.authProvider.googleLogin()
      .then((res) => {

      })
      .catch((err) => console.log(err));
  }

  // alertMessage
  alertMessage(title: string, errorMessage: any) {
    let alrtCtrl = this.alrtCtrl.create({
      title: title,
      subTitle: errorMessage,
      buttons: [{
        text: 'Ok',
        role: 'cancel'
      }]
    });
    alrtCtrl.present();
  }


  goBack() {
    this.navCtrl.setRoot(WelcomePage);
  }

  goToSinup() {
    this.navCtrl.setRoot(SignupPage);
  }

  goResetPassword() {
    this.navCtrl.setRoot(ResetpasswordPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }
  guestLogin() {
    this.navCtrl.setRoot(RestaurantslistPage);
  }
  ionViewWillEnter() {
    this.animation.smartAnimation().setType("fadeIn").show(this.logAnimate.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts